import React, { useState, useEffect } from 'react';
import './Pages/PagesCss/NavBar.css';
import logo from './assets/logo.png';

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">

          {/* Logo */}
          <a href="/" className="navbar-logo" onClick={closeMenu}>
            <img
              src={logo}
              alt="QuickPDFs"
              className="logo-image"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div className="logo-wordmark">
              <span className="logo-a">Quick</span>
              <span className="logo-b">PDFs</span>
              <span className="logo-c">.net</span>
            </div>
          </a>

          {/* Desktop Nav Links */}
          <ul className="nav-menu">
            <li>
              <a href="/" className="nav-link active">Home</a>
            </li>
            <li>
              <a href="/PDFMerger" className="nav-link active">
                Merge PDF
              </a>
            </li>
            <li>
              <a href="/PDFSplit" className="nav-link active">
                Split PDF
              </a>
            </li>
            <li>
              <a href="/PDFExtractPages" className="nav-link active">
                Extract Pages
              </a>
            </li>
            <li>
              <a href="/PDFOrganizer" className="nav-link active">
                Organize PDF
              </a>
            </li>
            <li>
              <a href="/PDFTools" className="nav-link active">
                All Tools
              </a>
            </li>
          </ul>

          {/* Auth Buttons */}
          {/* <div className="nav-buttons">
            <button className="btn btn-login">Sign In</button>
            <button className="btn btn-signup">Sign Up</button>
          </div> */}

          {/* Hamburger */}
          <div
            className={`menu-icon ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </div>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${isMenuOpen ? 'active' : ''}`} role="dialog">
        <div className="mobile-overlay" onClick={closeMenu} />
        <div className="mobile-panel">

          {/* Panel Header */}
          <div className="mobile-panel-header">
            <div className="logo-wordmark">
              <span className="logo-a">Quick</span>
              <span className="logo-b">PDFs</span>
              <span className="logo-c">.net</span>
            </div>
            <button className="mobile-close-btn" onClick={closeMenu} aria-label="Close">✕</button>
          </div>

          {/* Nav Links */}
          <nav className="mobile-nav">
            <a href="/" className="mobile-nav-link active" onClick={closeMenu}>
              <span>Home</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="/PDFMerger" className="mobile-nav-link" onClick={closeMenu}>
              <span>PDF Merger</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="/PDFSplit" className="mobile-nav-link" onClick={closeMenu}>
              <span>PDF Split</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="/PDFExtractPages" className="mobile-nav-link" onClick={closeMenu}>
              <span>Extract Pages</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="/PDFOrganizer" className="mobile-nav-link" onClick={closeMenu}>
              <span>PDF Organizer</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="/PDFTools" className="mobile-nav-link" onClick={closeMenu}>
              <span>All Tools</span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </nav>

          {/* Auth Buttons */}
          {/* <div className="mobile-auth">
            <button className="btn btn-login mobile-btn" onClick={closeMenu}>Sign In</button>
            <button className="btn btn-signup mobile-btn" onClick={closeMenu}>Sign Up</button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default NavBar;